import React from 'react';
import { ReservationForm } from '../components/ReservationForm';
export function Reservas() {
  return <div className="pt-24 md:pt-28" data-id="element-353">
      <ReservationForm data-id="element-354" />
    </div>;
}